import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-landing-popup',
  templateUrl: './landing-popup.component.html',
  styleUrls: ['./landing-popup.component.scss'],
})
export class LandingPopupComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
